import { Modal, ModalProps } from '@/modules/common/components/Modal';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

type FormValues = {
  confirm: boolean | null;
};

type ConfirmDeleteMemberModalProps = Omit<
  ModalProps,
  'title' | 'subtitle' | 'actions' | 'onClose'
> & {
  onClose(data?: FormValues): Promise<void>;
};

export function ConfirmDeleteMemberModal({
  onClose,
  ...props
}: ConfirmDeleteMemberModalProps) {
  const {
    handleSubmit,
    setValue,
    formState: { isSubmitting },
  } = useForm<FormValues>({
    defaultValues: {
      confirm: null,
    },
    resolver: yupResolver(
      yup.object().shape({
        confirm: yup.boolean().required().nullable(),
      }),
    ),
  });

  return (
    <Modal
      title="Delete this member"
      onClose={() => onClose(undefined)}
      actions={
        <>
          <Button
            form="confirm-delete-member-form"
            type="submit"
            variant="outlined"
            onClick={() => setValue('confirm', false)}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            form="confirm-delete-member-form"
            type="submit"
            variant="outlined"
            onClick={() => setValue('confirm', true)}
            loading={isSubmitting}
          >
            Delete
          </Button>
        </>
      }
      {...props}
    >
      <form
        onSubmit={e => handleSubmit(onClose)(e)}
        id="confirm-delete-member-form"
      >
        <Typography>Are you sure you want to delete this member?</Typography>
        <Typography>
          By clicking 'Delete', you will permanently remove this member from the
          company, including their access and related data. This action cannot
          be undone. Please confirm to proceed.
        </Typography>
      </form>
    </Modal>
  );
}
